module.exports = __webpack_public_path__ + "static/media/Genie Girl.654672bb.jpg";